import React from 'react';

export const LegalDisclaimer: React.FC = () => {
    return (
        <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold text-gold mb-8">Legal Disclaimer</h1>
            
            <div className="space-y-8 text-gray-300 leading-relaxed">
                <section>
                    <h2 className="text-2xl font-semibold text-gold mb-4">Company Information</h2>
                    <p className="mb-4">
                        Aureus Alliance Holdings (Pty) Ltd is a South African company registered under the laws of the Republic of South Africa.
                        The company owns and operates gold mining concessions covering 250 hectares of gold-rich land, with plans to
                        acquire additional land annually to expand operations.
                    </p>
                    <p className="mb-4">
                        <strong>Company Registration:</strong> 2025/368711/07<br/>
                        <strong>Registered Address:</strong> 1848 Mees Avenue, Randpark Ridge, Randburg, Gauteng, 2169<br/>
                        <strong>Website:</strong> aureus.africa<br/>
                        <strong>Business Activity:</strong> Gold placer deposit mining and processing operations
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gold mb-4">Share Ownership - Not Financial Investment Products</h2>
                    <p className="mb-4">
                        <strong>IMPORTANT CLARIFICATION:</strong> The purchase of shares in Aureus Alliance Holdings (Pty) Ltd
                        constitutes direct equity ownership in a South African mining company, not the purchase of financial
                        investment products, securities, or collective investment schemes as defined under South African
                        financial services legislation.
                    </p>
                    <div className="bg-amber-900/20 border border-amber-500/30 rounded-lg p-4 mb-6">
                        <h3 className="text-lg font-semibold text-amber-400 mb-2">What You Are Purchasing:</h3>
                        <ul className="list-disc list-inside space-y-2 text-gray-300">
                            <li>Direct ownership shares in Aureus Alliance Holdings (Pty) Ltd</li>
                            <li>Proportional ownership of company assets including mining concessions</li>
                            <li>Rights to dividends from gold mining operations</li>
                            <li>Voting rights in company decisions (where applicable)</li>
                            <li>Participation in company growth and expansion</li>
                        </ul>
                    </div>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gold mb-4">Risk Factors</h2>
                    <p className="mb-4">Share ownership in mining operations involves inherent risks including:</p>
                    <ul className="list-disc list-inside space-y-2 mb-4">
                        <li>Fluctuations in gold prices and market conditions</li>
                        <li>Operational risks related to mining activities</li>
                        <li>Regulatory changes affecting mining operations</li>
                        <li>Environmental and safety considerations</li>
                        <li>Economic and political factors in South Africa</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gold mb-4">Jurisdiction and Governing Law</h2>
                    <p className="mb-4">
                        This disclaimer and all matters relating to share ownership in Aureus Alliance Holdings (Pty) Ltd
                        are governed by the laws of the Republic of South Africa. Any disputes shall be subject
                        to the exclusive jurisdiction of the South African courts.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gold mb-4">Contact Information</h2>
                    <p className="mb-4">
                        For legal inquiries or questions about share ownership:<br/>
                        Email: info@aureus.africa<br/>
                        Address: 1848 Mees Avenue, Randpark Ridge, Randburg, Gauteng, 2169<br/>
                        Website: aureus.africa
                    </p>
                </section>

                <div className="border-t border-gray-600 pt-6 mt-8">
                    <p className="text-sm text-white">
                        Last Updated: {new Date().toLocaleDateString()}<br/>
                        This disclaimer is effective as of the date last updated.
                    </p>
                </div>
            </div>
        </div>
    );
};
